"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _buttons = require("../buttons");

var _crownBadge = _interopRequireDefault(require("../crown-badge/crown-badge"));

const UpgradeButton = (_ref) => {
  let {
    className,
    children
  } = _ref,
      otherProps = (0, _objectWithoutProperties2.default)(_ref, ["className", "children"]);
  return /*#__PURE__*/_react.default.createElement(_buttons.PrimaryButton, (0, _extends2.default)({}, otherProps, {
    className: (0, _classnames.default)('upgrade-button', className)
  }), /*#__PURE__*/_react.default.createElement(_crownBadge.default, {
    className: "upgrade-button__crown"
  }), children);
};

UpgradeButton.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.node.isRequired
};
UpgradeButton.defaultProps = {
  className: ''
};
var _default = UpgradeButton;
exports.default = _default;